const MessageA7 = (props) => {
  const timeCurrent =
    new Date().toLocaleTimeString("en-us").split(":")[0] +
    ":" +
    new Date().toLocaleTimeString("en-us").split(":")[1] +
    " " +
    new Date().toLocaleTimeString("en-us").substr(-2);

  return (
    <div className="send-text-wrap">
      <span style={{display : 'flex' , justifyContent : 'end'}} className="packs-text">{props.item.text}</span>{" "}
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="delivery-time-first">
          {timeCurrent}
          {/* <span>
            <svg
              fill="currentColor"
              preserveAspectRatio="xMidYMid meet"
              height="13"
              width="13"
              viewBox="0 0 40 40"
              class="ori-lr-mrgn-3"
            >
              <g>
                <path d="m14.5 26.6l18-18 2.5 2.4-20.5 20.4-9.5-9.5 2.5-2.4z"></path>
              </g>
            </svg>
          </span> */}
          <span style={{ marginLeft: '4px', display: 'flex', alignItems: 'center' }} >

            <img
              // style={{ width: "160px", cursor: "pointer" }}
              src={props?.TickIcon}
              alt="tick"
            />
          </span>
        </div>
      </div>
      <svg class="chat-tail" width="10" height="15" viewBox="0 0 10 10">
          <polygon points="0,0 20,0 10,10" fill="rgba(214, 198, 244, 1)" />
      </svg>
    </div>
  );
};

export default MessageA7;
